import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function VisuelRapportModal({
  handleClose,
  show,
  image,
  addOrUpdateVR,
  handleImageChange,
  setImage,
  errorFormatFile,
  errorNotASquare,
  errorHeavyFile,
  warningTooSmall,
  nameModal,
}) {
  return (
    <Modal
      show={show}
      size="lg"
      onHide={() =>
        window.confirm("Êtes-vous sûr de quitter sans valider ?")
          ? handleClose()
          : ""
      }
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{nameModal} un visuel</Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          const reader = new FileReader();
          reader.onload = () => {
            const base64 = reader.result.split(",")[1];
            addOrUpdateVR(base64);
          };
          reader.readAsDataURL(image);
        }}
      >
        <Modal.Body>
          <Form.Group controlId="fromBasicImage">
            <Form.Label>Télécharger une image</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => {
                handleImageChange(e);
              }}
            />
          </Form.Group>
          { /*
          <div
            className="drop-box text-center border rounded p-3"
            onDrop={(e) => {
              e.preventDefault();
              const selectedFile = e.dataTransfer.files[0];
              setImage(selectedFile);
            }}
            onDragOver={(e) => e.preventDefault()}
          >
          
          </div>
          */ }
          <div className="text-center p-3">
            <p className="mb-3">
              Cliquez sur "Choisir un fichier" ou 
              glisser et déposer le fichier dans le cadre ci dessus &uarr;<br />
              pour l'importer
            </p>
            <p className={`m-0 ${errorFormatFile ? "red" : ""}`}>
              Formats acceptés : JPG ou PNG
            </p>
            <p className="m-0">
              <span className={`m-0 ${errorNotASquare ? "red" : ""}`}>
                Votre visuel doit être dans un format carré (L = l) et
              </span>{" "}
              <span className={`m-0 ${errorHeavyFile ? "red" : ""}`}>
                ne pas peser plus de 2,5Mo.
              </span>
            </p>
            <p className={`m-0 ${warningTooSmall ? "text-warning" : ""}`}>
              Résolution conseillée : 1500 x 1500
            </p>
          </div>
          {image && (
            <div className="text-center">
              <img
                src={URL.createObjectURL(image)}
                width="300px"
                height="300px"
                alt="preview"
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="is-bottom-right">
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
            }}
          >
            Annuler
          </Button>
          <Button
            variant="success"
            type="submit"
            disabled={
              !image || errorNotASquare || errorHeavyFile || errorFormatFile
            }
          >
            Valider
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
